var map = {
	"./backgrounds/claim_one_bg.png": 8769,
	"./backgrounds/claim_one_bg.webp": 1272,
	"./pins/pin_fastio.svg": 979,
	"./pins/pin_spot.svg": 2697,
	"./sliders/slider_eight.png": 2,
	"./sliders/slider_eight.webp": 6510,
	"./sliders/slider_five.jpg": 7128,
	"./sliders/slider_five.webp": 9576,
	"./sliders/slider_four.png": 6225,
	"./sliders/slider_four.webp": 2672,
	"./sliders/slider_nine.jpg": 8867,
	"./sliders/slider_nine.webp": 4013,
	"./sliders/slider_one.jpg": 9091,
	"./sliders/slider_one.webp": 3233,
	"./sliders/slider_seven.jpg": 5694,
	"./sliders/slider_seven.webp": 5229,
	"./sliders/slider_six.png": 9398,
	"./sliders/slider_six.webp": 6506,
	"./sliders/slider_three.jpg": 9296,
	"./sliders/slider_three.webp": 4413,
	"./sliders/slider_two.jpg": 8157,
	"./sliders/slider_two.webp": 9224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8165;